import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import ConfiguracaoAprovacaoFilialService from "../../services/resource/configuracaoAprovacaoFilialService";
import FilialService from "../../services/resource/filialService";
import GrupoService from "../../services/resource/grupoService";

const service = new ConfiguracaoAprovacaoFilialService();
const filialService = new FilialService();
const grupoService = new GrupoService();

export function useConfiguracaoAprovacaoFilial(tipoProcesso) {
    const [configs, setConfigs] = useState([]);
    const [filiais, setFiliais] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const carregar = useCallback(() => {
        if (!tipoProcesso) {
            setConfigs([]);
            return;
        }
        setLoading(true);
        service.listarPorProcesso(tipoProcesso)
            .then(res => setConfigs(res.data))
            .catch(error => {
                console.error("Erro ao listar configurações de filial x aprovação", error);
                toast.error("Erro ao carregar configurações de Filial x Aprovação");
            })
            .finally(() => setLoading(false));
    }, [tipoProcesso]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    useEffect(() => {
        filialService.listarAtivas().then(res => setFiliais(res.data)).catch(() => setFiliais([]));
        grupoService.listarGrupos().then(res => setGrupos(res.data)).catch(() => setGrupos([]));
    }, []);

    // Salva todas as etapas de uma filial de uma vez (uma linha de config por etapa) — `itens` é
    // [{ id, etapaCodigo, grupoAprovacaoId }], id nulo = criar, grupoAprovacaoId nulo com id = remover.
    function salvarFilial(filialId, itens) {
        setSaving(true);
        const chamadas = itens.map(item => {
            if (item.grupoAprovacaoId == null) {
                return item.id ? service.excluir(item.id) : Promise.resolve();
            }
            const dados = { tipoProcesso, etapaCodigo: item.etapaCodigo, filialId, grupoAprovacaoId: item.grupoAprovacaoId };
            return item.id ? service.atualizar(item.id, dados) : service.cadastrar(dados);
        });
        return Promise.all(chamadas)
            .then(() => {
                toast.success("Configuração da filial salva com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao salvar configuração de filial x etapa", error);
                toast.error("Erro ao salvar configuração da filial");
                throw error;
            })
            .finally(() => setSaving(false));
    }

    // Remove todas as configurações (todas as etapas) de uma filial para o processo atual.
    function excluirFilial(ids) {
        return Promise.all(ids.map(id => service.excluir(id)))
            .then(() => {
                toast.success("Configurações da filial removidas com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao excluir configurações de filial x etapa", error);
                toast.error("Erro ao excluir configurações da filial");
                throw error;
            });
    }

    return { configs, filiais, grupos, loading, saving, recarregar: carregar, salvarFilial, excluirFilial };
}
